import { render, staticRenderFns } from "./SpN.vue?vue&type=template&id=13ccbf40"
import script from "./SpN.vue?vue&type=script&lang=js"
export * from "./SpN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports